import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import initialState from '../initialState'
import { NavigationTab, NavigationTabIcon } from '../types'

const slice = createSlice({
  name: 'appNavigationBottomNavDraft',
  initialState,
  reducers: {
    updateNavigationTab: (
      state,
      action: PayloadAction<{
        id: string | number
        data: Partial<NavigationTab>
      }>
    ) => {
      const id = String(action.payload.id)
      if (state.navigation_tabs[id]) {
        state.navigation_tabs[id] = {
          ...state.navigation_tabs[id],
          ...action.payload.data,
        }
        state.hasChanges = true
      }
    },
    resetChanges: state => {
      state.hasChanges = false
    },
    setChanges: state => {
      state.hasChanges = true
    },
    reset: (state, action: PayloadAction<NavigationTab[]>) => {
      // Clear existing tabs and set new ones
      state.navigation_tabs = {}
      action.payload.forEach((tab: NavigationTab) => {
        if (tab.id) {
          state.navigation_tabs[String(tab.id)] = tab
        }
      })
      state.hasChanges = false
    },
    updateNavigationTabIcon: (
      state,
      action: PayloadAction<{
        tabId: string | number
        iconType: 'default_icon' | 'selected_icon'
        iconData: NavigationTabIcon
      }>
    ) => {
      const { tabId, iconType, iconData } = action.payload
      const id = String(tabId)
      if (state.navigation_tabs[id]) {
        state.navigation_tabs[id][iconType] = iconData
        state.hasChanges = true
      }
    },
    removeNavigationTabIcon: (
      state,
      action: PayloadAction<{
        tabId: string | number
        iconType: 'default_icon' | 'selected_icon'
      }>
    ) => {
      const { tabId, iconType } = action.payload
      const id = String(tabId)
      if (state.navigation_tabs[id]) {
        state.navigation_tabs[id][iconType] = undefined
        state.hasChanges = true
      }
    },

    // Modal actions
    openDeleteModal: (state, action: PayloadAction<string | number>) => {
      state.deleteModal.isOpen = true
      state.deleteModal.tabId = action.payload
    },
    closeDeleteModal: state => {
      state.deleteModal.isOpen = false
      state.deleteModal.tabId = null
    },
  },
})

export const reducer = slice.reducer
export const {
  updateNavigationTab,
  resetChanges,
  setChanges,
  reset,
  updateNavigationTabIcon,
  removeNavigationTabIcon,
  openDeleteModal,
  closeDeleteModal,
} = slice.actions
